import {
  InvoiceItemTaxesIbsCbsCst,
  InvoiceItemTaxesIbsZfmPresumedCreditType,
  InvoiceItemTaxesRegularTaxIbsCbsCst,
} from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/invoiceNoteItems.enums';
import {
  IcmsBaseCalculationDeterminationMode,
  IcmsExemptionReason,
  IcmsOrigin,
  IcmsStDeterminationMode,
  InvoiceIcmsCstCsosn,
  IpiCst,
  PisCofinsCst,
  RelevanceScaleIndicatorEnum,
  TaxRegimeEnum,
} from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Moment } from 'moment';

export enum ufConsumption {
  AC = 'AC',
  AL = 'AL',
  AM = 'AM',
  AP = 'AP',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MG = 'MG',
  MS = 'MS',
  MT = 'MT',
  PA = 'PA',
  PB = 'PB',
  PE = 'PE',
  PI = 'PI',
  PR = 'PR',
  RJ = 'RJ',
  RN = 'RN',
  RO = 'RO',
  RR = 'RR',
  RS = 'RS',
  SC = 'SC',
  SE = 'SE',
  SP = 'SP',
  TO = 'TO',
  EX = 'EX',
}

export const ufConsumptionOptions = Object.values(ufConsumption).map((uf) => ({
  value: uf,
  label: uf,
}));

export interface InvoiceItemTaxIs {
  selectiveTaxCst?: string;
  selectiveTaxClassificationCode?: string;
  selectiveTaxBaseCalculationValue?: number;
  selectiveTaxAliquot?: number;
  selectiveTaxSpecificRateValue?: number;
  selectiveTaxTaxableUnitMeasure?: string;
  selectiveTaxTaxableQuantity?: number;
  selectiveTaxValue?: number;
}

export interface InvoiceItemTaxIbsCbs {
  ibsCbsCst?: InvoiceItemTaxesIbsCbsCst;
  ibsCbsTaxClassification?: string;
  ibsCbsDonation?: string;
  ibsCbsBaseCalculation?: number;
  ibsUfAliquot?: number;
  ibsUfReductionAliquot?: number;
  ibsUfEffectiveAliquot?: number;
  ibsUfDefermentPercentage?: number;
  ibsUfDefermentValue?: number;
  ibsUfPercentageReturned?: number;
  ibsUfTaxReturned?: number;
  ibsUfValue?: number;
  ibsMunicipalAliquot?: number;
  ibsMunicipalReductionAliquot?: number;
  ibsMunicipalEffectiveAliquot?: number;
  ibsMunicipalDeferralPercentage?: number;
  ibsMunicipalDeferralValue?: number;
  ibsMunicipalPercentageReturned?: number;
  ibsMunicipalTaxReturned?: number;
  ibsMunicipalValue?: number;
  ibsTotalValue?: number;
  cbsAliquot?: number;
  cbsReductionAliquot?: number;
  cbsEffectiveAliquot?: number;
  cbsDeferralPercentage?: number;
  cbsDeferralValue?: number;
  cbsPercentageReturned?: number;
  cbsTaxReturned?: number;
  cbsValue?: number;
  // Regular taxation ---
  regularTaxIbsCbsCst?: InvoiceItemTaxesRegularTaxIbsCbsCst;
  regularTaxIbsCbsClassificationCode?: string;
  regularTaxIbsUfAliquotPercentage?: number;
  regularTaxIbsUfValue?: number;
  regularTaxIbsMunicipalAliquotPercentage?: number;
  regularTaxIbsMunicipalValue?: number;
  regularTaxCbsAliquotPercentage?: number;
  regularTaxCbsValue?: number;
  // Government Procurement ---
  govPurchaseIbsUfAliquotPercentage?: number;
  govPurchaseIbsUfValue?: number;
  govPurchaseIbsMunicipalAliquotPercentage?: number;
  govPurchaseIbsMunicipalValue?: number;
  govPurchaseCbsAliquotPercentage?: number;
  govPurchaseCbsValue?: number;
  // Single Phase ---
  monoQuantity?: number;
  monoAdRemIbsAliquotPercentage?: number;
  monoAdRemCbsAliquotPercentage?: number;
  monoIbsValue?: number;
  monoCbsValue?: number;
  monoRetentionQuantity?: number;
  monoRetentionAdRemIbsAliquotPercentage?: number;
  monoRetentionIbsValue?: number;
  monoRetentionAdRemCbsAliquotPercentage?: number;
  monoRetentionCbsValue?: number;
  monoRetainedQuantity?: number;
  monoRetainedAdRemIbsAliquotPercentage?: number;
  monoRetainedIbsValue?: number;
  monoRetainedAdRemCbsAliquotPercentage?: number;
  monoRetainedCbsValue?: number;
  monoDeferralIbsPercentage?: number;
  monoDeferralIbsValue?: number;
  monoDeferralCbsPercentage?: number;
  monoDeferralCbsValue?: number;
  monoItemIbsTotal?: number;
  monoItemCbsTotal?: number;
  // Single Phase Ad Valorem / Ad Rem qBC — NT v1.50 (produção 03/11/2026).
  // NÃO usar na v1.40; reativar quando a v1.50 entrar em vigor.
  // ibsMonoAdValoremVBcMono?: number;
  // ibsMonoAdValoremPAliqMonoUf?: number;
  // ibsMonoAdValoremVIbsMonoUf?: number;
  // ibsMonoAdValoremPAliqMonoMun?: number;
  // ibsMonoAdValoremVIbsMonoMun?: number;
  // ibsMonoAdValoremVBcMonoReten?: number;
  // ibsMonoAdValoremPAliqMonoReten?: number;
  // ibsMonoAdValoremVIbsMonoReten?: number;
  // ibsMonoAdValoremVIbsMonoRet?: number;
  // cbsMonoAdRemQBcMono?: number;
  // cbsMonoAdRemQBcMonoReten?: number;
  // cbsMonoAdValoremVBcMono?: number;
  // cbsMonoAdValoremPAliqMonoCbs?: number;
  // cbsMonoAdValoremVCbsMono?: number;
  // cbsMonoAdValoremVBcMonoReten?: number;
  // cbsMonoAdValoremPAliqMonoReten?: number;
  // cbsMonoAdValoremVCbsMonoReten?: number;
  // cbsMonoAdValoremVCbsMonoRet?: number;
  // Competency Adjustment ---
  competenceApuration?: Moment;
  competenceIbsValue?: number;
  competenceCbsValue?: number;
  // Credit Transfers/Reversal ---
  creditTransferIbsValue?: number;
  creditTransferCbsValue?: number;
  creditReversalIbsValue?: number;
  creditReversalCbsValue?: number;
  // Presumed Credit ---
  classificationCodePresumedCredit?: string;
  ibsPresumedCreditPercentage?: number;
  ibsPresumedCreditValue?: number;
  ibsPresumedCreditSuspensiveConditionValue?: number;
  cbsPresumedCreditPercentage?: number;
  cbsPresumedCreditValue?: number;
  cbsPresumedCreditSuspensiveConditionValue?: number;
  // Presumed Credit IBS ZFM ---
  ibsZfmAssessmentPeriod?: Moment;
  ibsZfmPresumedCreditType?: InvoiceItemTaxesIbsZfmPresumedCreditType;
  ibsZfmPresumedCreditValue?: number;
}

export interface InvoicePartFormValues {
  taxPreset?: number;

  // Flags de UI que expandem as seções da aba IBS/CBS quando há dados
  enableIbsCbsCredPres?: boolean;
  enablePresumedCreditIbsZfm?: boolean;
  enableTribRegular?: boolean;
  enableGov?: boolean;
  enableMono?: boolean;
  enableAjusteCompet?: boolean;
  enableCreditTransfersReversal?: boolean;

  general: {
    partId?: number;
    consumableId?: number;
    description?: string;
    unitMeasurement?: string;
    ncmId?: number;
    cest?: string;
    cfopId?: number;
    quantity?: number;
    valueUnitary?: number;
    barCode?: string;
    otherValue?: number;
    valueDiscount?: number;
    freightValue?: number;
    insuranceValue?: number;
    valueTotal?: number;
    relevanceScaleIndicator?: RelevanceScaleIndicatorEnum;
    manufacturerMerchandiseCnpj?: string;
    taxBenefitCode?: string;
    approximateTaxValue?: number;
    purchaseNumber?: string;
    purchaseOrder?: string;
    nve?: string;
    exTipi?: string;
    additionalInformation?: string;
    keyNfePurchase?: string;
    itemNumberPurchase?: string;
  };

  itemTaxes: {
    icms: {
      taxRegime?: TaxRegimeEnum;
      icmsCst?: InvoiceIcmsCstCsosn;
      icmsOrigin?: IcmsOrigin;
      icmsSimpleNationalCreditPercentage?: number;
      icmsSimpleNationalCreditValue?: number;
      icmsAliquot?: number;
      icmsBaseCalculationDeterminationMode?: IcmsBaseCalculationDeterminationMode;
      icmsBaseCalculationValue?: number;
      icmsBaseCalculationReductionPercentage?: number;
      icmsValue?: number;
      icmsStAliquot?: number;
      icmsStDeterminationMode?: IcmsStDeterminationMode;
      icmsStBaseCalculationValue?: number;
      icmsStBaseCalculationReductionPercentage?: number;
      icmsStValueAddedMarginPercentage?: number;
      icmsDestinyUfBaseCalculationValue?: number;
      icmsDestinyUfValue?: number;
      icmsStValue?: number;
      icmsStFcpAliquot?: number;
      icmsStFcpBaseCalculationValue?: number;
      icmsStFcpValue?: number;
      icmsFcpAliquot?: number;
      icmsFcpBaseCalculationValue?: number;
      icmsExemptionValue?: number;
      icmsExemptionReason?: IcmsExemptionReason;
      icmsDefermentPercentage?: number;
      icmsDefermentValue?: number;
      icmsDefermentDueValue?: number;
      icmsEffectiveBaseCalculationValue?: number;
      icmsEffectiveBaseCalculationReductionPercentage?: number;
      icmsEffectiveAliquot?: number;
      icmsEffectiveValue?: number;
      shouldNotDeductExemptIcms?: boolean;
    };

    share: {
      icmsBaseCalculationShare?: number;
      fcpBaseCalculationShare?: number;
      icmsFcpPercentageShare?: number;
      internalAliquotShare?: number;
      interstateAliquotShare?: number;
      fcpRelativeIcmsShare?: number;
      interstateIcmsShare?: number;
    };

    ipi: {
      ipiProducerCnpj?: string;
      ipiLegalClassificationCode?: string;
      ipiCst?: IpiCst;
      ipiAliquot?: number;
      ipiBaseCalculation?: number;
      ipiValue?: number;
      ipiControlSealCode?: string;
      ipiControlSealQuantity?: number;
      ipiUnitValue?: number;
      ipiUnitQuantity?: number;
      returnedGoodsPercentage?: number;
      returnedIpiValue?: number;
    };

    pis: {
      pisCst?: PisCofinsCst;
      pisAliquot?: number;
      pisValue?: number;
      pisBaseCalculationValue?: number;
      pisSoldQuantity?: number;
      pisRealAliquot?: number;
      pisStAliquot?: number;
      pisStValue?: number;
      pisStBaseCalculation?: number;
      pisStSoldQuantity?: number;
      pisStRealAliquot?: number;
    };

    cofins: {
      cofinsCst?: string;
      cofinsAliquot?: number;
      cofinsValue?: number;
      cofinsBaseCalculationValue?: number;
      cofinsSoldQuantity?: number;
      cofinsRealAliquot?: number;
      cofinsStAliquot?: number;
      cofinsStValue?: number;
      cofinsStBaseCalculation?: number;
      cofinsStSoldQuantity?: number;
      cofinsStRealAliquot?: number;
    };

    irpjCsll: {
      csllBaseCalculationValue?: number;
      csllWithheldRate?: number;
      csllWithheldValue?: number;
      irrfBaseCalculationValue?: number;
      irrfWithheldRate?: number;
      irrfWithheldValue?: number;
    };

    is?: InvoiceItemTaxIs;

    ibsCbs?: InvoiceItemTaxIbsCbs;
  };

  fuel?: {
    anpDescription?: string;
    glpPercentage?: number;
    gnnPercentage?: number;
    gniPercentage?: number;
    startingValue?: number;
    anpCode?: string;
    authorizationCode?: string;
    ambientTemperatureBilling?: number;
    consumptionState?: string;
    cideCalculationBase?: number;
    cideTaxRate?: number;
    cideValue?: number;
    startValue?: number;
    endValue?: number;
    nozzleNumber?: string;
    tankNumber?: string;
    pumpNumber?: string;
  };
}

export interface InvoicePartNcmChangeFormValues {
  general: {
    cest?: string;
    approximateTaxValue?: number;
  };

  itemTaxes: {
    icms: {
      icmsBaseCalculationDeterminationMode?: IcmsBaseCalculationDeterminationMode;
      icmsCst?: InvoiceIcmsCstCsosn;
      icmsAliquot?: number;
    };

    ipi: {
      ipiCst?: IpiCst;
      ipiAliquot?: number;
    };

    pis: {
      pisCst?: PisCofinsCst;
      pisAliquot?: number;
    };

    cofins: {
      cofinsCst?: string;
      cofinsAliquot?: number;
    };
  };
}
